import React from 'react';
import TablaEstadoCuentaExpendedores from '../components/agentes/tablaEstadoCuenta';

function estadoCuentaExpendedores() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaEstadoCuentaExpendedores />
      </div>
  );
}

export default estadoCuentaExpendedores;




// WEBPACK FOOTER //
// ./src/pages/estadocuentaexpendedor.js